<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}退单原因
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(returnTypeEdit && tenant.id != null) || (returnTypeAdd && tenant.id == null)"
                     @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    退单原因编码
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.returnCode" @blur="inspection" clearable />
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    退单原因名称
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="tenant.returnName" clearable />
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    退单后工单流向
                  </th>
                  <td>
                    <el-select v-model="tenant.returnDisrect">
                      <el-option label="不退回厂家" :value=0 />
                      <el-option label="退回厂家" :value=1 />
                      <el-option label="直接关闭" :value=2 />
                    </el-select>
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    启用
                  </th>
                  <td>
                    <el-select v-model="tenant.usable">
                      <el-option label="禁用" :value=0 />
                      <el-option label="启用" :value=1 />
                    </el-select>
                  </td>
                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    排序
                  </th>
                  <td>
                    <el-input-number min="0" max="10" style="width:165px" :controls="false" v-model="tenant.seq"/>
                  </td>
                </tr>

                <tr>
                  <th>
                    匹配服务类型
                  </th>
                  <td colspan="7" class="table-row">
                    <div class="table-cell">
                      <el-cascader v-model="tenant.serviceTypeNames" :key="tenant.value" :options="serviceTypeOption"  style="width: 100%;"
                                   :props="serviceTypeProps"
                                   clearable
                      ></el-cascader>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>创建人</th>
                  <td>{{ tenant.createBy }}</td>
                  <th>创建时间</th>
                  <td>{{ tenant.createTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
      @confirm="confirmCategory" />
  </div>
</template>
<script>
  import {
    initVxeTable
  } from '@/const/crud/admin/table';
  import Tinymce from '@/components/Tinymce';
  import request from "@/router/axios";
  import api from "@/api/projectApi";
  import {mapGetters} from "vuex";
  import {editPageMixins} from "@/mixins/tabChang";
  import serviceTypeDialog from "@/views/dialogCommon/serviceTypeDialog.vue";
  export default {
    mixins: [editPageMixins],
    name: 'edit',
    props: {
      _dataId: [String, Number]
    },
    components: {
      Tinymce,
      serviceTypeDialog,
    },
    data() {
      return {
        serviceTypeProps:{multiple: true},
        serviceTypeOption: [],
        returnTypeAdd: false,
        returnTypeEdit: false,
        img_b: "",
        upload_btn: false, // 是否隐藏上传图片按钮
        radio: '1',
        showEdit: false,
        valuetype: 'model',
        textarea: '',
        //  value1: true,
        value2: false,
        value3: true,
        activeName: 'first',
        dialog: {
          one: false,
        },
        lan: 'zh_CN',
        isEdit: false,
        tabIndex: 'first',
        dataId: '',
        // 基本信息
        service: {
          pic: ''
        },
        tenant: {
          serviceTypeIds: '',
          serviceTypeNames: [],
          id: null,
          status: 0,
          tenantAttachmentDTOs: [],
          returnName: '',
          returnCode:'',
          returnDisrect:0,
          usable: 1,
          seq: 0,
        },
        showProductCategoryDialog: false,
      };
    },
    computed: {
      ...mapGetters(["permissions"])
    },
    created() {
      this.returnTypeAdd = this.permissions['return_type_add']
      this.returnTypeEdit = this.permissions['return_type_edit']

      if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
      // console.log(this.tenant,"tenant的值");
    },
    mounted() {

      this.getData();
      this.loadServiceTypeOptions()
      console.log(this.tenant, "tenant的值");
      console.log(this._dataId, "_dataId的值");
    },
    methods: {

      // 加载服务类型
      loadServiceTypeOptions() {
        this.$http.post(api.basServiceType.getOptionUrl, {}).then(res => {
          // console.log(res.data.data, 'option')
          let list = []
          res.data.data.forEach(item => {
            if (item.children.length == 0) {
              delete item.children
            }
            list.push(item)
          })
          this.serviceTypeOption = list
          console.log(this.serviceTypeOption,"服务类实现");
        })
      },

      inspection() {
        if (this.tenant.returnCode) {
          this.$http({
            url: api.basReturnType.inspectionUrl,
            method: 'post',
            data: {
              value: this.tenant.returnCode,
              id: this.tenant.id,
            }
          }).then(res => {
            if (!res.data.data) {
              this.$message.warning("退单原因编码已存在，请重新输入")
              this.tenant.returnCode = null
            }
          })
        }
      },



      getData() {
        console.log('data',this.dataId);
        if (this.dataId && !isNaN(this.dataId)) {
          this.isEdit = true;
          request({
            url: '/basic/basReturnType/get',
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.tenant = response.data.data;
            console.log("------>",this.tenant);
            console.log("返回服务类型:"+response.data.data.serviceTypeOptions)
            this.tenant.serviceTypeNames = response.data.data.serviceTypeOptions;
          })
        } else {
          // this.enabled = true;
        }
      },
      saveData() {
        var typeIds = "";
        if(this.tenant.serviceTypeNames != null){
          this.tenant.serviceTypeNames.forEach(item => {
            typeIds += item + ","
          })
        }
        if(typeIds != null && typeIds != ""){
          typeIds = typeIds.slice(0,typeIds.length-1);
        }

        this.tenant.serviceTypeIds = typeIds;
        if(typeIds == ""){
          this.tenant.serviceTypeIds = "0";
        }

        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$baseConfirm('您确定要保存吗？').then(() => {
              this.$mask.open()

              var url = (this.isEdit ? `/basic/basReturnType/update` : `/basic/basReturnType/save`);
              this.$http({
                url: url,
                method: `post`,
                data: this.tenant,
                isLoading: true,
              }).then(res => {
                this.$message.success("保存成功！")
                // this.$emit('editViewDataUpdate')
                this.goBackIndex()
                this.$mask.close()

              }).catch(e => {
                console.error(e)
                this.$message.error("保存失败！")
                this.$mask.close()

              });
            });
          }
        });
      },
      confirmCategory(rows) {
        if (rows.length > 0) {
          let row = rows[0];
          this.tenant.itemCatId = row.id;
          this.tenant.itemCatName = row.categoryName;
          this.tenant.itemCatCode = row.categoryCode;
        }
      },
    },
  };

</script>
<style lang="scss" scoped>
</style>
